export function sameProtocolTreeId(
  left: string | null | undefined,
  right: string | null | undefined
): boolean {
  return left != null && right != null && left === right;
}
